//export const ENDPOINT = 'https://aplikace-dev.mimedigital.cz/';
export const ENDPOINT = 'https://aplikace.mimedigital.cz/';
//export const ENDPOINT = 'http://localhost:8000/';
export const ESHOP_TOKEN = 'I2PlF7@O7AlMljW^RS4I@0XZ^1';